import { UIComponentHandler, UIComponentState, UIDataModel, UIComponentProps, UIComponentImpl } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { FeaturedCategoryViewImpl } from './featuredview';
import { FeaturedCategoryCSSStyleImpl } from './featuredcategorycss';
import { FeaturedCategoryAPIModel, FeaturedCategoryAPIModelImpl } from './featuredcategoryapimodel';
import { FeaturedCategoryDto } from 'src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorydto';

export interface FeaturedCategoryComponentProps extends UIComponentProps
{
    
}

export interface FeaturedCategoryComponentHandler extends UIComponentHandler
{
    onTabSelected(title: string, id: string): void;
}

export class FeaturedCategoryComponent extends UIComponentImpl<FeaturedCategoryComponentProps, UIComponentState, UIDataModel> implements FeaturedCategoryComponentHandler
{
    constructor(props: FeaturedCategoryComponentProps)
    {
        super(props);
    }
    onTabSelected(title: string, id: string): void 
    {
        (this.getView() as FeaturedCategoryViewImpl).showLoader();
        (this.getAPIModel() as FeaturedCategoryAPIModel).getFeaturedCategoriesBasedOnTitle(title, id);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FeaturedCategoryViewImpl(applicationContext, uiComponentHandler);
    }

    componentDidMount()
    {
        (this.getAPIModel() as FeaturedCategoryAPIModel).getFeaturedCategories();
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FeaturedCategoryCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new FeaturedCategoryAPIModelImpl(applicationContext, apiModelHandler);
    }

    setFeaturedCategoryMap(featuredCategoryMap: Map<string, string>)
    {
        (this.getView() as FeaturedCategoryViewImpl).setFeaturedCategoryMap(featuredCategoryMap);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("featuer: " + feature);

        (this.getView() as FeaturedCategoryViewImpl).dismissLoader();

        if(feature === APIFeatures.SEARCH_TONE)
        {
            (this.getView() as  FeaturedCategoryViewImpl).updateProfileTab(this.props.context, 
                (data as FeaturedCategoryDto).getTitle(), (data as FeaturedCategoryDto).getListOfTones());
        }
        else
        {
                (this.getView() as  FeaturedCategoryViewImpl).updateTabData(this.props.context, 
                    (data as FeaturedCategoryDto).getTitle(), (data as FeaturedCategoryDto).getListOfTones());
        }
        
        // if(this.count === 0)
        // {
            (this.getView() as  FeaturedCategoryViewImpl).updateTab((data as FeaturedCategoryDto).getTitle());
        // }

        window.scrollTo(0,0);
    }

    onFailure(feature: APIFeatures, description: string, data: any)
    {
        (this.getView() as FeaturedCategoryViewImpl).dismissLoader();
        window.scrollTo(0,0);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/featuredcomponent.tsx